module.exports = __webpack_public_path__ + "img/illu-tadpole.53ee157e.svg";